<script setup>
import ReportPage from '../components/ReportPage.vue'
import StatusTag from '../components/StatusTag.vue'
</script>

<template>
  <ReportPage
    :section="`health-inventory-${pageIndex}`"
    eyebrow="부록 · 검진 항목 전체"
    :title="pageIndex === 0 ? '확인한 건강검진 항목 전체' : '확인한 건강검진 항목 · 계속'"
    :lead="pageIndex === 0 ? '본문에 다 싣지 않은 검사값도 원문 값 그대로 보존합니다.' : ''"
    :customer-name="report.customer.name"
  >
    <table class="exam">
      <thead><tr><th class="t-name">검사항목</th><th class="t-val">결과</th><th class="t-ref">참고범위</th><th class="t-st">상태</th><th>원문 소견</th></tr></thead>
      <tbody>
        <tr v-for="metric in items" :key="metric.metricKey">
          <td class="t-name">{{ metric.name }}</td>
          <td class="t-val"><b>{{ metric.value ?? '—' }}</b> <small>{{ metric.unit || '' }}</small></td>
          <td class="t-ref">{{ metric.reference || '—' }}</td>
          <td class="t-st"><StatusTag :state="metric.state"  /></td>
          <td class="t-note">{{ metric.comment || '—' }}</td>
        </tr>
      </tbody>
    </table>
  </ReportPage>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true },
    report: { type: Object, required: true },
    pageIndex: { type: Number, required: true }
  }
}
</script>
